import 'reflect-metadata'
import '@babel/polyfill'
// Side-effect import: extends dayjs with the plugins aqe components depend on
// (utc, timezone, customParseFormat, isSameOrBefore, isSameOrAfter,
// localizedFormat). Replaces the previous local setupDayjs() — single source
// of truth shared with halocline.
import '@pushly/aqe/lib/dayjs-setup'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
// import './styles/globals.scss'

import './_utils/utils'
import { setupAxios } from './config/axios-setup'
import { setupLocalization } from './config/locale-setup'
import { setupAqe } from './config/aqe-setup'
import { Maintenance503 } from './components/503/maintenance-503'
import { App } from './app'
import { PlatformIdentityProvider } from './providers/platform-identity-provider/platform-identity-provider'
import { ThemeProvider } from './providers/theme-provider/theme-provider'
import { ThemePreferenceSync } from './providers/theme-provider/theme-preference-sync'
import { UserProvider } from './providers/user-provider/user-provider'
import { BrowserRouter } from 'react-router-dom'
import { startVisibilityObserver } from './_utils/visibility-api'
import Highcharts from 'highcharts'

setupAxios()
setupLocalization()
setupAqe()

startVisibilityObserver()

Highcharts.setOptions({
    chart: {
        backgroundColor: 'transparent',
    },
    title: {
        style: { color: 'var(--color-black)' },
    },
    legend: {
        itemStyle: { color: 'var(--color-black)' },
        itemHoverStyle: { color: 'var(--color-dark-gray)' },
    },
})

let AppComponent: any = App
if (process.env.MAINT_MODE === 'on') {
    AppComponent = Maintenance503
}

const container = document.getElementById('root')

ReactDOM.createRoot(container!).render(
    <BrowserRouter>
        <PlatformIdentityProvider>
            <ThemeProvider>
                <UserProvider>
                    <ThemePreferenceSync />
                    <AppComponent />
                </UserProvider>
            </ThemeProvider>
        </PlatformIdentityProvider>
    </BrowserRouter>,
)
